import { useState, useEffect } from 'react';
import AuthAnimatedModal from 'components/shared/modal/AuthAnimatedModal';
import SchoolFeesPreviewModal from 'components/shared/modal/SchoolFeesPreviewModal';
import { RoutePaths } from 'routes/route-paths';
import { useNavigate } from 'react-router-dom';
import {
  sendCatchFeedback,
  sendFeedback,
} from '../../../../functions/feedback';
import Fireworks from 'react-canvas-confetti/dist/presets/fireworks';
import { v4 as uuidv4 } from 'uuid';
import { formatPhoneNumber, formatToNaira } from 'functions/currencyConveter';
import { appAxios } from 'api/axios';
import ProgressLoader from 'components/shared/loader/successLoader';
import { getTokenDetails } from 'functions/userSession';
import { decodeToken } from 'react-jwt';
import { TokenType } from 'types/jwt';
import CustomStepper from 'components/shared/stepper';
import MySelfStep1 from 'components/user/individualSchoolSteps/authenticated/Step1';
import MySelfStep2 from 'components/user/individualSchoolSteps/authenticated/Step2';

interface FormData {
  FirstName: string;
  LastName: string;
  Email: string;
  ContactAddress: string;
  PhoneNumber: string;
  utilityBill: File | null;
  validId: File | null;

  EducationLevel: string;
  CourseOfStudy: string;
  InstitutionName: string;
  InstitutionAddress: string;
  InstitutionAddress1: string;
  InstitutionAddress2: string;
  City: string;
  State: string;
  PostalCode: string;
  Country: string;
  TuitionFees: string;
  LoanAmount: string;
  TuitionFeeInvoice: File | null;
  OfficialSchoolID: File | null;

  Occupation: string;
  EmployersName: string;
  MonthsOfWorkinWithThem: string;
  YearsOfWorkinWithThem: string;
  OfficialEmail: string;
  HrContactPhoneNumber: string;
  EmployerContactAddress1: string;
  EmployerAddress1: string;
  EmployerAddress2: string;
  City2: string;
  State2: string;
  PostalCode2: string;
  Country2: string;
  PaySlip: File | null;
  BankStatement: File | null;
  TermsCondition: boolean;
  // LoanAgreement: boolean;
}

const MySelfSchoolFeePage = () => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [CustomerId, setCustomerId] = useState('');
  const [idempotencyKey, setIdempotencyKey] = useState(uuidv4());
  const getClientId = () => {
    const token = getTokenDetails();
    if (!token) {
      return;
    }
    const decodedToken = decodeToken<TokenType>(token);
    if (decodedToken) {
      setCustomerId(decodedToken?.customerId);
    }
  };

  useEffect(() => {
    getClientId();
  }, []);
  const handleProceed = () => {
    setIsModalOpen(false);
    navigate(RoutePaths.USER_DASHBOARD);
  };
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);

  const clearErrors = (field: string) => {
    setErrors((prevErrors) => ({ ...prevErrors, [field]: '' }));
  };
  const [inputData, setInputData] = useState<FormData>({
    FirstName: '',
    LastName: '',
    Email: '',
    ContactAddress: '',
    PhoneNumber: '',
    utilityBill: null,
    validId: null,

    EducationLevel: '',
    CourseOfStudy: '',
    InstitutionName: '',
    InstitutionAddress: '',
    InstitutionAddress1: '',
    InstitutionAddress2: '',
    City: '',
    State: '',
    PostalCode: '',
    Country: '',
    TuitionFees: '',
    LoanAmount: '',
    TuitionFeeInvoice: null,
    OfficialSchoolID: null,

    Occupation: '',
    EmployersName: '',
    MonthsOfWorkinWithThem: '',
    YearsOfWorkinWithThem: '',
    OfficialEmail: '',
    HrContactPhoneNumber: '',
    EmployerContactAddress1: '',
    EmployerAddress1: '',
    EmployerAddress2: '',
    City2: '',
    State2: '',
    PostalCode2: '',
    Country2: '',
    PaySlip: null,
    BankStatement: null,
    TermsCondition: false,
    // LoanAgreement: false,
  });

  const nextStep = () => {
    if (currentStep < 3) {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const prevStep = () => setCurrentStep((prev) => Math.max(prev - 1, 0));

  const handleFormData = (data: Partial<FormData>) => {
    setInputData((prev) => ({ ...prev, ...data }));
  };

  const tuitionAmount = parseFloat(
    inputData?.TuitionFees.toString().replace(/,/g, '')
  );

  const loanAmount = parseFloat(
    inputData?.LoanAmount.toString().replace(/,/g, '')
  );

  const getPreviewContent = () => {
    return (
      <div>
        <>
          <h4 className="text-left font-semibold mb-1">Education Details</h4>
          <div className="grid grid-cols-1 text-left mb-3 sm:grid-cols-2 gap-4">
            <div>
              <p>
                <strong>Course of Study:</strong> {inputData.CourseOfStudy}
              </p>

              <p className=" capitalize ">
                <strong>Education Level:</strong> {inputData.EducationLevel}
              </p>
              <p>
                <strong>Institution Name:</strong>{' '}
                {`${inputData.InstitutionName}`}
              </p>
            </div>
            <div>
              <p>
                <strong>Institution Address:</strong>{' '}
                {`${inputData.InstitutionAddress || ''}
                 ${inputData.InstitutionAddress1 || ''} ${inputData.InstitutionAddress2 || ''}
                 ${inputData.City || ''}
                 ${inputData.State || ''}
                 ${inputData.Country || ''}`}
              </p>

              <p>
                <strong>Tuitution Fee:</strong>{' '}
                {formatToNaira(tuitionAmount) || 0}
              </p>
              <p>
                <strong>Loan Amount:</strong> {formatToNaira(loanAmount) || 0}
              </p>
            </div>
          </div>
        </>

        <>
          <h4 className="text-left font-semibold mb-1">Employer's Details</h4>
          <div className="grid grid-cols-1 text-left mb-3 sm:grid-cols-2 gap-4">
            <div>
              <p>
                <strong>Your Occupation:</strong> {inputData.Occupation}
              </p>

              <p>
                <strong>Employers's Name:</strong> {inputData.EmployersName}
              </p>
              <p>
                <strong>HR Phone Number:</strong>{' '}
                {`+${inputData.HrContactPhoneNumber}`}
              </p>
            </div>
            <div>
              <p>
                <strong>Employer's Address:</strong>{' '}
                {`${inputData.EmployerContactAddress1}  ${inputData.EmployerAddress1 || ''}
                 ${inputData.EmployerAddress2 || ''}
                 ${inputData.City2 || ''}
                 ${inputData.State2 || ''}
                 ${inputData.Country2 || ''}`}
              </p>

              <p>
                <strong>Employer's Offical Email Address:</strong>{' '}
                {inputData.OfficialEmail}
              </p>
              <p>
                <strong>Duration Of Working With your Employer:</strong>{' '}
                {`${inputData.YearsOfWorkinWithThem || 0} years ${inputData.MonthsOfWorkinWithThem || 0} months`}
              </p>
            </div>
          </div>
        </>
      </div>
    );
  };

  const handlePreview = () => {
    setIsPreviewModalOpen(true);
  };

  const handlePreviewConfirm = () => {
    setIsPreviewModalOpen(false);
    completeSchoolForm();
  };

  const completeSchoolForm = async () => {
    setLoading(true);
    const formData = new FormData();
    // const isValid = await validateStep(currentStep);

    if (inputData.utilityBill) {
      formData.append(
        'UtilityBill',
        inputData.utilityBill,
        inputData?.utilityBill?.name
      );
    } else {
      sendFeedback('Utility bill is required.', 'error');
      setLoading(false);
      return;
    }

    if (inputData.validId) {
      formData.append(
        'UtilityBill',
        inputData.validId,
        inputData?.validId?.name
      );
    } else {
      sendFeedback('Valid ID is required.', 'error');
      setLoading(false);
      return;
    }

    // Education Info
    formData.append(
      'EducationDetailRequest.EducationLevel',
      inputData.EducationLevel
    );
    formData.append(
      'EducationDetailRequest.CourseOfStudy',
      inputData.CourseOfStudy
    );
    formData.append(
      'EducationDetailRequest.InstitutionName',
      inputData.InstitutionName
    );
    formData.append(
      'EducationDetailRequest.InstitutionAddress',
      `${inputData.InstitutionAddress || inputData.InstitutionAddress1 || inputData.InstitutionAddress2} ${inputData.City} ${inputData.State} ${inputData.PostalCode} ${inputData.Country}`
    );
    formData.append('EducationDetailRequest.Zip', inputData.PostalCode);
    formData.append('EducationDetailRequest.TuitionFee', inputData.TuitionFees);
    formData.append('EducationDetailRequest.LoanAmount', inputData.LoanAmount);
    formData.append('IdempotencyKey', idempotencyKey);
    formData.append('CustomerId', CustomerId);

    // Handle Tuition Fee Invoice file
    if (inputData.TuitionFeeInvoice) {
      formData.append(
        'EducationDetailRequest.TuitionFeeInvoice',
        inputData.TuitionFeeInvoice,
        inputData.TuitionFeeInvoice.name
      );
    } else {
      sendFeedback('Tuition Fee Invoice is required.', 'error');
      setLoading(false);
      return;
    }

    // Handle Official School ID file
    if (inputData.OfficialSchoolID) {
      formData.append(
        'EducationDetailRequest.OfficialSchoolId',
        inputData.OfficialSchoolID,
        inputData.OfficialSchoolID.name
      );
    } else {
      sendFeedback('Official School ID is required.', 'error');
      setLoading(false);
      return;
    }

    // Employment Info
    formData.append(
      'EmploymentIncomeInformationRequest.Occupation',
      inputData.Occupation
    );
    formData.append(
      'EmploymentIncomeInformationRequest.EmployerName',
      inputData.EmployersName
    );
    formData.append(
      'EmploymentIncomeInformationRequest.EmploymentDuration',
      `${inputData.YearsOfWorkinWithThem}years ${inputData.MonthsOfWorkinWithThem}months`
    );
    formData.append(
      'EmploymentIncomeInformationRequest.OfficialWorkEmail',
      inputData.OfficialEmail
    );
    formData.append(
      'EmploymentIncomeInformationRequest.HRCompanyContactNumber',
      formatPhoneNumber(inputData.HrContactPhoneNumber)
    );
    formData.append(
      'EmploymentIncomeInformationRequest.EmployerContactAddress',
      `${inputData.EmployerContactAddress1 || inputData.EmployerAddress1} ${inputData.City2} ${inputData.State} ${inputData.PostalCode2} ${inputData.Country2}`
    );

    if (inputData.BankStatement) {
      formData.append(
        'EmploymentIncomeInformationRequest.MonthsBankStatement',
        inputData.BankStatement,
        inputData.BankStatement.name
      );
    } else {
      sendFeedback('Bank statement is required.', 'error');
      setLoading(false);
      return;
    }
    if (inputData.PaySlip) {
      formData.append(
        'EmploymentIncomeInformationRequest.MonthsPayslip',
        inputData.PaySlip,
        inputData.PaySlip.name
      );
    } else {
      formData.append(
        'EmploymentIncomeInformationRequest.MonthsPayslip',
        inputData.BankStatement,
        inputData.BankStatement.name
      );
    }
    formData.append(
      'AgreedToTermsAndConditions',
      `${inputData.TermsCondition}`
    );

    try {
      const { data } = await appAxios.post(
        '/register-customer-otherschoolfee-service',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (data.success) {
        sendFeedback(data?.message, 'success');
        setShowConfetti(true);
        setIsModalOpen(true);
        setLoading(false);
        setIdempotencyKey(uuidv4()); // Generate a new key after successful submission

        setIsSubmitModalOpen(true);
      } else {
        sendCatchFeedback(data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error, 'error');
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showConfetti) {
      const timer = setTimeout(() => {
        setShowConfetti(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [showConfetti]);

  useEffect(() => {
    let interval: number | null = null;
    if (loading) {
      const interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 100) {
            // clearInterval(interval!);
            // return 100;
            return 1;
          }
          return prevProgress + 5;
        });
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [loading]);
  const stepsArray = [
    {
      stepLabel: 'Step:1 Education Details',
      stepDescription: 'Education Details',
      completed: currentStep > 0 ? true : false,
    },

    {
      stepLabel: 'Step:2 Employment & Income Information',
      stepDescription: '',
      completed: currentStep > 1 ? true : false,
    },
  ];
  return (
    <div className="sm:flex block h-full bg-BrandBg3 py-4 px-6 ">
      {loading && (
        <ProgressLoader progress={progress} titleText="Please wait... " />
      )}
      <div className="w-full flex gap-7 lg:flex-row flex-col-reverse ">
        <div className="flex-1  bg-white shadow-card p-8 rounded-md">
          {showConfetti && (
            <Fireworks
              autorun={{ speed: 3 }}
              width={windowWidth}
              height={windowHeight}
            />
          )}
          <div className="form-content">
            {currentStep === 0 && (
              <MySelfStep1
                inputData={inputData}
                setInputData={handleFormData}
                errors={errors}
                clearErrors={clearErrors}
                prevStep={prevStep}
                nextStep={nextStep}
              />
            )}
            {currentStep === 1 && (
              <MySelfStep2
                inputData={inputData}
                setInputData={handleFormData}
                errors={errors}
                clearErrors={clearErrors}
                prevStep={prevStep}
                nextStep={handlePreview}
                loading={loading}
              />
            )}
          </div>
        </div>
        <CustomStepper currentStep={currentStep} steps={stepsArray} />
      </div>

      <AuthAnimatedModal
        isOpen={isModalOpen}
        onClose={handleProceed}
        onConfirm={handleProceed}
        title="Service Form Submitted!"
        btnText="Proceed"
        content={
          <p>
            You have successfully submitted your service form, Kindly check your
            email to complete the process.
          </p>
        }
      />
      <SchoolFeesPreviewModal
        isOpen={isPreviewModalOpen}
        onClose={() => setIsPreviewModalOpen(false)}
        title="Preview Your Submission"
        btnText="Submit"
        content={getPreviewContent()}
        onConfirm={handlePreviewConfirm}
      />
    </div>
  );
};

export default MySelfSchoolFeePage;
